/** function for generate errors from BE for delete charging card */
export const deleteChargingCardApiErrors: Record<string, string> = {
  INVALID_OR_MISSING_CREDENTIALS: 'emobility.api-errors.invalid-credentials',
  LACK_OF_PERMISSIONS: 'emobility.api-errors.lack-permissions',
  TOKEN_LINK_NOT_FOUND: 'emobility.api-errors.token-link-not-found',
}

/** function for generate errors from BE for edit charging card and assign user to charging card */
export const editChargingCardApiErrors: Record<string, string> = {
  INVALID_OR_MISSING_CREDENTIALS: 'emobility.api-errors.invalid-credentials',
  LACK_OF_PERMISSIONS: 'emobility.api-errors.lack-permissions',
  TOKEN_LINK_NOT_FOUND: 'emobility.api-errors.token-link-not-found',
  BAD_REQUEST: 'emobility.api-errors.bad-request',
  ACCOUNT_LINK_NOT_FOUND: 'emobility.api-errors.account-no-found',
  USER_NOT_FOUND: 'emobility.api-errors.user-not-found',
  USER_NOT_ASSIGNED: 'emobility.api-errors.user-not-assigned',
  WALLBOX_NOT_ASSIGNED: 'emobility.api-errors.wallbox-no-assigned',
  TOKEN_IS_DELETED: 'emobility.api-errors.token-is-deleted',
  TOKEN_STATE_UNALLOWED: 'emobility.api-errors.token-state-unallowed',
  INVALID_TOKEN_STATUS: 'emobility.api-errors.token-status-invalid',
  INSTALLATION_NOT_FOUND: 'emobility.api-errors.installation-no-found',
  TOKEN_IS_EXPIRED: 'emobility.api-errors.token-is-expired',
}
